module.exports = __webpack_public_path__ + "static/media/photo2.730401ab.jpg";